<template>
    <div style="margin-left:5%;margin-right:5%">
        <el-container style="width: 100%;">
            <el-main>
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="filteredData.length"
                    :page-size="page_size"
                    align="center"
                    style="margin-top:20px;margin-bottom:20px"
                    @current-change="page_change"
                    :current-page.sync="currentPage"
                ></el-pagination>
                
                <el-container direction="vertical">
                    <el-row :gutter="20">
                        <el-col :span="3" v-for="(data, i) in paginatedData" :key="data.id" class="mouse_hover">
                            <el-card class="card" shadow="hover" :body-style="{ padding: '0px' }">
                                <el-image 
                                    :src="getImageUrl(data.filepath)" 
                                    class="image" 
                                    fit="cover"
                                    @click="convertessay(data.id)"
                                />
                                <div class="bottom clearfix">
                                    <div style="font-size: 15px;color: #999;text-align:center">
                                        {{ getFileName(data.filepath).slice(0, 15) }}
                                    </div>
                                </div>
                            </el-card>
                        </el-col>
                    </el-row>
                </el-container>
                
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="filteredData.length"
                    :page-size="page_size"
                    align="center"
                    style="margin-top:20px;margin-bottom:20px"
                    @current-change="page_change"
                    :current-page.sync="currentPage"
                ></el-pagination>
            </el-main>
        </el-container>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    data() {
        return {
            allData: [], // 存储所有数据
            filteredData: [], // 存储过滤后的数据
            article_count: 0,
            page_size: 32,
            currentPage: 1,
            loading: false,
            error: null,
            dialogVisible: false,
            currentImage: '',
        }
    },
    computed: {
        paginatedData() {
            // 计算当前页应该显示的数据
            const start = (this.currentPage - 1) * this.page_size;
            const end = start + this.page_size;
            return this.filteredData.slice(start, end);
        }
    },
    created() {
        this.fetchAllData();
    },
    methods: {
        async fetchAllData() {
            try {
                this.loading = true;
                const response = await axios.get('https://api.movie.yingshinet.com/collection');
                this.allData = response.data.c_data;
                this.article_count = response.data.c_count;
                
                // Filter data based on auth status
                const isLoggedIn = this.$store.state.login_state; // Check login state
                this.filteredData = isLoggedIn 
                    ? this.allData // Show all if logged in
                    : this.allData.filter(item => item.auth === "0"); // Only show auth=0 if not logged in
                
                this.updatePaginatedData();
            } catch (error) {
                this.error = '加载数据失败: ' + error.message;
                console.error('获取数据失败:', error);
            } finally {
                this.loading = false;
            }
        },
        page_change(page) {
            this.currentPage = page;
            this.updatePaginatedData();
        },
        updatePaginatedData() {
            // 根据当前页码更新显示的数据
            const start = (this.currentPage - 1) * this.page_size;
            const end = start + this.page_size;
            this.tableData = this.filteredData.slice(start, end);
        },
        getImageUrl(filepath) {
            return "https://assets.yingshinet.com/" + filepath.replace(/\\/g, '/');
        },
        getFileName(filepath) {
            return filepath.replace(/\\/g, '/').split('/').pop().replace('.jpg', '');
        },
        convertessay(id) {
            this.$router.push({
                path: '/letter_literature',  // 根据你的实际路由调整
                query: {
                    id: id,
                },
            })
        },
    }
}
</script>
  
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #e2a253 !important;
    color: #fff;
}

.el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #e2a253 !important;
}

.el-dialog__headerbtn .el-dialog__close:hover {
    color: #e2a253 !important;
}
</style>
  
<style scoped>
.mouse_hover:hover {
    cursor: pointer;
}

.image {
    width: 120px;
    height: 140px;
    display: block;
}

.card {
    width: 120px;
    height: 160px;
    margin-bottom: 20px;
}

.bottom {
    margin-top: 0px;
    line-height: 12px;
    padding-top: 5px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.image-container {
    overflow-y: auto;
    display: flex;
    justify-content: center;
    margin-top: 0px; /* 添加上边距，与按钮区域分开 */
}
.image-controls {
    display: flex;
    justify-content: flex-end; /* 改为右对齐 */
    align-items: center;
    gap: 10px;
    margin-bottom: 10px; /* 增加底部间距 */
    padding: 0px; /* 增加内边距 */
    
    border-radius: 4px;
    margin-right: 20px; /* 添加右侧间距 */
}
</style>